<template>
    <b-modal
            v-if="didacticial !== null"
            ref="modal"
            centered
            width="100"
            title="Didacticial"
            hide-header
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
            modal-class="didacticial-content"
            class="p-0">
        <b-row class="modal-body p-0"
               v-touch:swipe.left="nextImage"
               v-touch:swipe.right="previousImage">
            <b-col class="p-0 text-center chevron">
                <i
                        v-if="indexImage > 0"
                        class="fas fa-chevron-left"
                        @click="previousImage()"></i>
            </b-col>
            <b-col class="p-0">
                <b-img
                        class="mx-auto"
                        :src="`${appApiUrl}/../${images[indexImage]}`"
                        alt="image"
                        style="max-height: 500px; width: auto;"
                />
            </b-col>
            <b-col class="p-0 text-center chevron">
                <i
                        v-if="indexImage < images.length - 1"
                        class="fas fa-chevron-right"
                        @click="nextImage"></i>
            </b-col>
        </b-row>
        <b-row class="justify-content-center my-2 circles" v-if="images.length > 1">
            <i
                    v-for="(slide, key) in images"
                    :key="key"
                    :class="indexImage === key ? 'circle_active' : ''"
                    class="fas fa-circle mx-1"
            ></i>
        </b-row>
        <div
                v-if="indexImage === images.length - 1"
                class="mt-2">
            <div class="justify-content-center d-flex">
                <div class="pt-2">
                    <label
                            class="checkbox-label mx-2 mb-0"
                            for="showAgain">
                        Afficher à la prochaine connexion
                    </label>
                </div>
                <div class="checkboxBtn">
                    <input
                            type="checkbox"
                            id="showAgain"
                            v-model="showAgain"
                    />
                </div>
                <b-button
                        id="btnClose"
                        class="ml-2"
                        type="button"
                        variant="primary"
                        @click="done()">
                    Retour à l'application
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {APP_API_URL} from '@/utils/types/setting'

    export default {
        name: 'didacticial',
        props: {
            didacticial: Object
        },
        data: function () {
            return {
                indexImage: 0,
                isDesktop: window.innerWidth > 768,
                showAgain: false,
                desktopImages: [],
                mobileImages: []
            }
        },
        computed: {
            appApiUrl() {
                return this.$store.state.base.setting[APP_API_URL]
            },
            images() {
                return this.isDesktop ? this.desktopImages : this.mobileImages
            }
        },
        watch: {
            didacticial(value) {
                if (value === null) {
                    return this.$nextTick(() => {
                        if (!this.$refs.modal) return
                        this.$refs.modal.hide()
                    })
                }

                this.orderImages()
                this.showAgain = value.user_workflow_state === 'auth_enabled'
                return this.$nextTick(() => {
                    if (!this.$refs.modal) return
                    this.$refs.modal.show()
                })
            }
        },
        methods: {
            orderImages() {
                this.desktopImages = []
                this.mobileImages = []

                for (const image of this.didacticial.images) {
                    if (image.includes('desktop')) this.desktopImages.push(image)
                    else this.mobileImages.push(image)
                }
            },
            nextImage() {
                if (this.indexImage < this.images.length - 1) return this.indexImage++
            },
            previousImage() {
                if (this.indexImage > 0) return this.indexImage -= 1
            },
            async done() {
                const {status} = await this.$store.dispatch('base/didacticial/done', {
                    didacticialId: this.didacticial.id,
                    authRedirect: this.showAgain
                })
                this.$emit('close', status)
            }
        }
    }
</script>

<style lang="scss">
    .didacticial-content {
        .modal-content {
            background-color: rgba(0, 0, 0, 0);
        }

        @media (min-width: 576px) {
            .modal-dialog {
                max-width: 90% !important;
            }
        }
    }

    .chevron {
        i {
            cursor: pointer;
            font-size: 50px;
            position: relative;
            top: 50%;
            color: #FF9966;
        }
    }

    .circles {
        i {
            color: whitesmoke;
        }
    }

    .circle_active {
        color: #FF9966 !important;
    }

    .checkbox-label {
        color: whitesmoke;
    }

    .checkbox-label:hover {
        cursor: pointer;
        text-decoration: underline;
        text-decoration-color: whitesmoke;
    }

    .checkboxBtn {
        padding-top: 10px;
    }
</style>